export default {
  nav: {
    login: 'Login',
    logout: 'Logout',
    person: 'User Center',
    message: 'Message',
    my: 'My',
    request: 'Requisition',
    applicant: 'Purchase',
    purchaseReq: 'Purchase request',
    purchase: 'Purchase',
    projects: 'Project',
    favorite: 'Collection',
    approve: 'Approval',
    requestApprove: 'Requisition',
    applicantApprove: 'Purchase',
    borrow: 'Borrowing information',
    myBorrow: 'My borrowing',
    post: 'Post borrowing',
    statistic: 'Statistics',
    requestStatistic: 'Requisition',
    approveStatistic: 'Approval',
    waste: 'Waste collection',
    search: 'Please enter the Name, CAS, Material ID., Product No., specification and other key to retrieve inventory information',
    structSearch: 'Search',
    cart: 'Requisition list',
    location: 'Current position',
    home: 'Home',
    myFavorite: 'My collection',
    myMessage: 'My message',
    materielList: 'Material list',
    claimHistory: 'My Requisition',
    myApply: 'My purchase request',
    materialBorrow: 'Material Borrow',
    notification: 'Notification',
    noAuth: 'No Auth',
    myProcurement: 'My purchase',
    requestDetails: 'Request Details',
    requestSuccess: 'Request Success',
    wasteCollection: 'Waste Collection',
    wasteRegister: 'Waste Register',
    wasteAdd: 'Waste Add',
    wasteEdit: 'Waste Edit',
    edit: 'Edit',
  },
  page: {
    yuan: 'yuan',
    fileReg: 'Wrong file format',
    fileTypes: 'Wrong file format, upload {0} files',
    maxFileSize: 'File size must not greater than {0}',
    consumeQuantity: 'Consume Qty',
    manned: 'Normal',
    unmanned: 'Self-service',
    outStock: 'Out Stock',
    subOutStock: 'Sub Stock',
    childStructSearch: 'childStructSearch',
    exactSearch: 'exactSearch',
    similarSearch: 'similarSearch',
    copyright: 'Copyright：© {0} NeoTrident Techonology Ltd.  ',
    date: 'Date',
    noAuth: 'remind',
    splitStockTip: 'Some Materials Are Expected To Be Equal To The Amount Of Equipment And It Will Be Turned Into The Whole Bottle',
    expiryDate: 'Expired',
    overExpiryTime: 'Expired',
    withExpiryTime: 'Near',
    inExpiryTime: 'Valid',
    purchaseOrder: 'Purchase Order',
    exportPurchaseFileName: 'Order',
    screenLock: 'Screen lock',
    psd: 'password',
    more: 'More',
    all: 'All',
    read: 'Read',
    unread: 'UnRead',
    notice: 'Notification',
    noticeDetail: 'Notices Detail',
    notice1: 'Notice',
    notice2: 'announcement',
    myBorrow: 'My borrowed',
    mylend: 'My lent',
    taBorrow: 'Other',
    approveCount: 'Approved quantity',
    approveMoney: 'Approved Money',
    materiel: 'Materials',
    warehouse: 'Warehouse',
    warehouseName: 'warehouse name',
    supplier: 'Supplier',
    sAndp: 'Supplier/Producer',
    close: 'Put up',
    open: 'Expand',
    reagent: 'Chemicals',
    materielNumber: 'Material ID.',
    molecularFormula: 'Molecular formula',
    molecularWeight: 'Molecular weight',
    accurateMass: 'Accurate Molecular weight',
    appearance: 'Appearance',
    stereoisomerDescription: 'stereoisomer description',
    alias: 'Alias',
    requesthistory: 'Requisition history',
    approvehistory: 'Approval history',
    thisReagent: 'The reagent is',
    Dangerous: 'Dangerous',
    explosive: 'explosive',
    Pretoxic: 'Precursor',
    Toxic: 'Highly Toxic',
    noteUse: ', Please pay attention to use.',
    yes: 'Yes',
    no: 'no',
    cartToolTip: 'The material will be recycled automatically after remaining time is over, please submit the requsition ASAP!',
    cartSelectInfo: '(Selected {0} of {1}) Other operations',
    continueRequest: 'Continue requisition',
    deleteSelected: 'Delete selected',
    emptyAll: 'Clear the requisition list',
    noMaterielFind: 'No material found',
    load: 'Data loading complete',
    loadMore: 'load more',
    noFavorite: 'No favorites',
    requisition: 'Purchase request',
    addRequisition: 'Purchase info',
    inventoryQuantity: 'InventoryQuantity',
    inventoryInfo: 'Inventory',
    materielInfo: 'Material information',
    noInventoryInfo: 'No inventory found',
    lend: 'borrow',
    compound: 'Compound',
    chartType: 'Chart type',
    lineChart: 'Line chart',
    histogram: 'Histogram',
    statisticTime: 'Statistics Time',
    report: 'Report',
    data: 'Data',
    requestData: 'Requisition data',
    returnData: 'Return data',
    scrappData: 'Scrap data',
    yourMateriel: 'Hello, your requisition material (',
    in: ') to',
    beginDelivery: 'Start shipping, please prepare to receive',
    baseInfo: 'Basic Information',
    applicantInfo: 'Purchase Information',
    purchasing: 'Material in purchase',
    approveYes: 'Completion',
    approveNo: 'Rejected',
    materialDetail: 'Material details',
    materialInfo: 'Material information',
    chemProperty: 'Physical and chemical properties',
    density: 'density',
    meltlingPoint: 'Melting point',
    boilingPoint: 'Boiling point',
    flashPoint: 'Flash point',
    refractiveIndex: 'Refractive index',
    vapourPressure: 'Vapor Pressure',
    stability: 'stability',
    sAndr: 'Storage and risk',

    incompatibilityInfo: 'Contraindications',
    storageCondition: 'Storage temperature conditions',
    gb: 'Risk Classification (National Standard)',
    gb1: 'explosive',
    gb2: 'Corrosive',
    gb3: 'High pressure gas',
    gb4: 'Environmental hazard',
    gb5: 'Health hazard',
    gb6: 'Oxide',
    gb7: 'Flammable',
    gb8: 'Toxic Chemicals',
    gb9: 'harmful',
    om: 'Risk Classification (EU)',
    om1: 'Risk description',
    om2: 'Danger statement',
    om3: 'safety instructions',
    om4: 'Precautionary statement',
    om5: 'Storage instructions',
    not: 'no',
    toxicityInfo: 'Toxicity information',
    customNumber: 'Custom number',
    OHS1: 'OHS number',
    OHS2: 'OHS name',
    other: 'other',
    requestInfo: 'Requisition Information',
    lifeCycle: 'Life cycle',
    library: 'in-storage',
    putIn: 'Storage-in',
    approveFlow1: 'To approve',
    approveFlow2: 'Rejected',
    approveFlow3: 'To pick up',
    approveFlow4: 'To storage-out',
    approveFlow5: 'To self-pickup',
    approveFlow6: 'To delivery',
    approveFlow7: 'Rejected',
    requestMateriel: 'Requisition materials',
    success1_1: 'Requisition submitted, please pay attention to the subsequent process and wait patiently!',
    success1_2: 'Congratulations, your requisition has been submitted,  please pay attention to the following process and wait patiently!',
    success2: 'Other operations',
    success3: 'View history',
    success4: 'Tips',
    success5_1: 'Requisition follow-up process: waiting for approval-warehouse processing flowchart',
    success5_2:
      'Following process: Material will  be out-stock and the requisition will be received automatically by default, but if the approval process was configured, the requisiton will become to-be-approved.',
    author: 'Author',
    requestState1: 'Submitted for approval',
    requestState19: 'To be picked',
    requestState200: 'Picking',
    requestState201: 'Picked to be delivery',
    requestState210: 'Picked fail',
    requestState300: 'Storage-out to be self-pick',
    requestState301: 'Storage-out to be deliver',
    requestState400: 'Delivering',
    requestState500: 'Signed',
    searchInfo0: 'no matching material info',
    searchInfo1: 'do you want',
    searchInfo2: 'or you can',
    searchInfo3: 'no matching material info in history records, need you to apply',
    searchInfo4: 'to search in histroy',
    applyNow: 'Apply Now',
    neotrident: 'Neotrident',
    mimp: 'Material information management platform',
    pageTitle: 'iLabPower CIMS Materials Requisition',
    exportAll: 'Export All',
    exportSelect: 'Export Selected',
    countAndmoney: 'count·money',
    Narcotic: 'Narcotic',
    Psychotropic: 'Psychotropic',
    Radioactive: 'Radioactive',
    Explosives: 'Explosives',
    attachment: 'attachment',
    requestable: 'requestable',
    requested: 'requested',
    toTop: 'Top',
  },
  message: {
    placeholder: 'Please enter {0}',
    placeSelect: 'Please select {0}',
    miniPlaceSelect: 'Please select',
    overZero: '{0} must be greater than 0',
    overAndZero: '{0} must be greater or equal to 0',
    notNull: '{0} cannot be empty',
    notOver: '{0} cannot be longer than {1} words',
    notOver1: '{0} integer cannot be longer than {1} words',
    notOver2: '{0} decimal cannot be longer than {1} words',
    onlyOne: 'select one item only',
    deleteTip: 'Are you sure you want to delete this content?',
    bottleTypeNoComplete: 'Package are not complete',
    noMateriel: 'This compound is not available in the base library, please enter the name manually',
    materielIsExisted: 'This reagent exists already',
    casIsError: 'CAS format is incorrect',
    applicantSuccess: 'Purchase successfully saved',
    paramsError: 'Parameter error',
    noAuth: 'No access',
    index: '{1} at line {0}',
    incomplete: '{0} is not complete',
    isInteger: '{0} must be a positive integer',
    notMore: '{0} not greater than {1}',
    mustMore: '{0} must greater than {1}',
    mustLess: '{0} must less than {1}',
    decimal: '{0} not greater {1} decimal',
    betweenorSame: '{0} must be greater than {1} and less {2} or equal',
    mustNum: '{0} must be number',
    arrivalNumberOverLimit: 'The delivered quantity should not be greater than the undelivered quantity',
    greaterOrEqual: '{0} must greater than or equal with {1}',
    lessOrEqual: '{0} must less than or equal with {1}',
  },
  btn: {
    reLogin: 'Re-login',
    defaultConfirm: 'Confirm',
    search: 'Search',
    add: 'New',
    remove: 'Delete',
    edit: 'Edit',
    submit: 'Submit',
    submiting: 'submitting',
    submitSucc: 'Submitted successfully',
    saving: 'Saving',
    saved: 'Save',
    saveDraft: 'Save draft',
    saveAndSubmit: 'Save and submit',
    success: 'Success',
    cancel: 'Cancel',
    preview: 'Preview',
    submitRequest: 'Submitted',
    _btnSubmit: 'Submit',
    return: 'Return',
    scrapp: 'Scrapped',
    store: 'Store',
    approveDetail: 'Detail',
    batchReturn: 'Batch return',
    batchScrapp: 'Batch scrap',
    batchStore: 'Batch storage',
    yes: 'Approve',
    no: 'Reject',
    batchYes: 'Batch approve',
    batchNo: 'Batch reject',
    batchReceive: 'Batch receiving',
    batchReceived: 'Batch receive',
    selectAll: 'Select all',
    cancelAll: 'Unselect all',
    doing: 'Processing',
    applicant: 'Purchase',
    batchSubmit: 'Batch submit',
    batchDelete: 'Batch delete',
    batchWithdrawal: 'Batch return',
    completelyNew: 'Completely new',
    addFrom: 'New from existing material',
    completelyApplicant: 'New purchase',
    exporting: 'Export',
    receiving: 'Accepting',
    exportPurchase: 'Export Purchase Order',
    purProcess: 'Purchase processing',
    settlementting: 'Billing',
    settlement: 'Settlement',
    enable: 'Available',
    disable: 'Disable',
    confirm: 'Confirmed',
    confirmReceive: 'Confirem receive',
    confirmLend: 'Confirm Lending Material',
    choose: 'Select',
    posting: 'announcing',
    post: 'Post Borrowing',
    viewHistory: 'View Requisition Record',
    lendNow: 'Lend Now',
    batchRead: 'Batch read',
    allMsg: 'All',
    approveMsg: 'Approval message',
    deliveryMsg: 'Delivery message',
    borrowMsg: 'Borrowing message',
    applicantMsg: 'Purchase message',
    viewMsgDetail: 'Click for details',
    domestic: 'Domestic',
    import: 'import',
    internal: 'Internal synthesis',
    purchaseInfo: 'Purchasing Information',
    massReject: 'Mass Reject',
    massReason: 'reject reason',
    massReason1: 'reject reason',
    massReasonPlaceholder: 'Please typing the reject reason,limited 1000',
    finishPurchase: 'Finished Purchase',
    finishReason: 'Finish Reason',
  },
  action: {
    add: 'New {0}',
    edit: 'Edit {0}',
    remove: 'Delete {0}',
  },

  form: {
    useFor: 'Use For',
    processMode: 'Disposal method',
    returnReason: 'Return reason',
    scrappedReason: 'Scrap reason',
    stroeLoc: 'Location',
    withdraw: 'withdraw',
    withdrawReason: 'Reason for withdrawal',
    try: 'Did not find? Try',
    notFind: 'No matched material found!',
    approvalIdea: 'Approve result',
    perfectPurInfo: 'Update Purchasing order information',
    fillReceiptInfo: 'Fill in the receipt information',
    projectName: 'Project number (name)',
    projectCode: 'Project Number',
    projectLeader: 'Manager',
    filter: 'Supports input search matching',
    projectMember: 'Members',
    projectDesc: 'Project description',
    projectDeleteTip1: 'Are you sure you want to delete ',
    projectDeleteTip2: ' ？',
    noDept: 'Department not assigned by current user',
    chooseMateriel: 'Select material',
    deadline: 'Deadline',
    note: 'Remark',
    chinName: 'Name',
    chinAlias: 'Chinese alias',
    chemName: 'English name',
    chemAlias: 'English alias',
    wasteTitle: 'Laboratory waste material collection record form',
    waste1: 'Waste material category / name',
    waste2: 'Category',
    waste3: 'Name',
    waste4: 'Ingredient',
    waste5: 'Generate and collect information',
    waste6: 'Company name',
    waste7: 'Laboratory name',
    waste8: 'Collector',
    waste9: 'Address / location',
    waste10: 'Contact number',
    waste11: 'Packaging / container',
    waste12: 'Container number',
    waste13: 'No.',
    waste14: 'Colour',
    waste15: 'Storage place',
    waste16: 'Region',
    waste17: 'Address / location',
    waste18: 'Waste material source',
    waste19: 'Source',
    waste20: 'Test, Test items and ingredients',
    waste21: 'Physical status of waste materials',
    waste22: 'Risk category',
    waste23: 'Storage time',
    waste24: 'Mixed collection schedule',
    waste25: 'Initial stored time',
    waste26: 'Mixed collection schedule (with quantity each time): can be attached',
    waste27: 'Quantity (total)',
    waste28: 'Other information',
    waste29: 'Handover processing time',
    waste30: 'Remark',
    waste31: 'Signature (Charger/Administrator)',
  },
  columns: {
    controlType: 'ControlType',
    requestCode: 'No.',
    receptionNo: 'Requisition No.',
    purchaseCode: 'No.',
    poNumber: 'Order ID.',
    bottleName: 'Name',
    materialName: 'Material Name',
    categoryCode: 'Material category',
    categoryName: 'Catg.',
    CASNumber: 'CAS',
    purity: 'Purity',
    purity1: 'Specification',
    requestQuantity: 'Amount',
    quantity: 'Quantity',
    estimatedAmount: 'Estimate',
    projectCode: 'Project',
    requestDate: 'Time',
    applyDate: 'Submit time',
    applicantDate: 'Submit time',
    approveUsersNames: 'Approver',
    approveUser: 'Approver',
    approveReason: 'Reject reason',
    requestState: 'Requisition status',
    requester: 'Requester',
    requisitionNo: 'Requisition No',
    price: 'Price',
    number: 'Amount',
    totalPrice: 'Total',
    applicant: 'Submitter',
    applyTime: 'Time',
    submitTime: 'Submit time',
    _submitTime: 'Submit time',
    procurementScheduleStatus: 'Status',
    barcode: 'Barcode',
    barcode1: 'Barcode',
    bottleType: 'Package',
    bOrp: 'Spec/Purity',
    currentQuantity: 'Available',
    currentAmount: 'Current amount',
    sublocation: 'Location',
    catalogNumber: 'Product No.',
    lotNumber: 'Lot No.',
    itemState: 'State',
    phone: 'Phone',
    delivery: 'Delivery',
    remainTime: 'Time left',
    operation: 'Operate',
    noDataText: 'Loading...',
    noDataText2: 'No data',
    state: 'Status',
    deliverer: 'Shipper',
    receiveDate: 'Receive time',
    completeTime: 'Return time',
    createTime: 'Create time',
    bfTime: 'Scrap time',
    applicantTime: 'Purchase time',
    estimatedArrival: 'Expected time',
    approveState: 'Approve status',
    expectationPeriod: 'Expected time',
    estimatedArrivalTime: 'Estimated arrive date',
    approveTime: 'Approve time',
    producer: 'Manufacturer',
    producer1: 'Producer',
    expiryDate: 'Expired',
    expireTime: 'Expired',
    origin: 'source',
    myProject: 'My project',
    desc: 'Description',
    user: 'User',
    demand: 'Demand',
    postTime: 'Time',
    _postTime: 'Post time',
    detail: 'Detail',
    lendTo: 'Lend to',
    lendMateriel: 'Material Name',
    LendCount: 'Amount',
    lentTime: 'Time',
    mdl: 'MDL number',
    requestHistory: 'Requisition records',
    lab: 'Lab',
    lnedTa: 'Lend to him',
    lnedMateriel: 'Borrowing materials',
    publisher: 'publisher',
    initialQuantity: 'Returned amount',
    comment: 'Comment',
    unitPrice: 'price',
    pruchasePrice: 'price',
    chemicalName: 'Name',
    chemicalType: 'Catg.',
    companyName: 'Company',
    numbering: 'No.',
    requestUnit: 'unit',
    title: 'Title',
    type: 'Type',
    effectiveDate: 'expiration date',
    settle: 'Liquidated',
    notSettle: 'Unliquidated',
    note: 'Remark',
    grossWeight: 'Gross Weight',
    restGoods: 'Remaining arrivals',
    arrivalQuantity: 'Arrival quantity',
    undeliveredQuantity: 'Undelivered quantity',
    dangerous: 'Dangerous',
  },
  unit: {
    bottle: 'bottle',
    l: 'L',
    ml: 'ML',
    g: 'G',
    kg: 'KG',
  },
  time: {
    time: 'time',
    day: 'day',
    month: 'month',
    hour: 'hour',
    zero: ' Zero ',
    expireDate: 'Requisition timeout, expired',
  },
  dic: {},
  tour: {
    buttonSkip: 'Skip the guide page',
    buttonPrevious: 'Previous',
    buttonNext: 'Next',
    buttonStop: 'Finish',
    content1: 'Enter Name, CAS and other conditions, separated by spaces, search for materials',
    content2: 'You can borrow and approve materials in the user center.',
    content3: 'Click here to view your borrowing information',
    content4: 'Others have also released borrowing, see if you can help',
    content5: 'Others have also released borrowing, see if you can help',
  },
  tab: {
    approving: 'To approve',
    approvTo: 'Approving',
    approved: 'Approved',
    receipting: 'To receive',
    rejected: 'Rejected',
    signed: 'Received',
    dispenssed: 'dispenssed',
    returned: 'Returned',
    scrapped: 'Scrapped',
    pending: 'To submit',
    processing: 'To process',
    processed: 'Processed',
    settle: 'Settled',
    placed: 'Ordered',
    receiving: 'To be received',
    received: 'Received',
    receipt: 'To arrive',
    arrived: 'Arrived',
    myBorrow: 'My borrowed',
    myLend: 'My lent',
    dispensed: 'dispensed',
    shelvedMsg: 'Shelved Message',
    returnBack: 'returned',
    pruchaseReturnBack: 'Buyer Reject',
    applicantRejected: 'Pruchase refused',
    ended: 'Ended',
  },
  key1: 'Coaster Dismissal Rejection：',
  key2: 'dismiss',
  key3: 'Fill In The Reable Information',
  key4: 'Actual Amount',
  key5: 'Rejecter',
  key6: 'Reject Time',
  key7: 'Reject Reason',
  key8: 'Note',
  key9: 'Producer',
  key10: 'NO.',
  key11: 'Note',
  key12: 'Exception',
  key13: 'Batch Settlement',
  key14: 'Warehouse',
  key15: 'Total project amount',
  key16: 'Accumulated outlay',
  key17: 'Remaining quota',
  key18: 'Agree',
  key19: 'Refuse',
  key20: 'Approve result',
  key21: 'StorageCondition',
  key22: 'Local project',
  key23: 'Request all in list',
  key24: 'Start at the cursor and fill from top to bottom',
  key25: 'Approval information',
  key26: "You've added {0} items to the pick list",
  key27: 'There are no items that can be collected',
  key28: 'The remaining amount',
  key29: 'Reuse',
  key30: 'View CMS structural formula',
  key31: 'Advanced Search',
  key32: 'Reset Conditions',
  key33: 'Modify Purchase Order',
  key34: 'User',
  key35: 'ProjectCode',
  key36: 'Experiment Number',
  key37: 'Use Time',
  key38: 'Usage Record',
  key39: 'Add',
  key40: 'Operator',
  key41: 'Operation Time',
  key42: 'Operation Type',
  key43: 'Old Value',
  key44: 'New Value',
  key45: 'The total usage of the usage record will exceed the current amount of the material, are you sure to add?',
  key46: 'Modification Reason',
  key47: 'Exceeding Reason',
  key48: 'The usage of {0} with barcode {1} is modified to {2}',
  key49:
    'It has exceeded the current amount of the material and cannot be returned to the warehouse. Please modify the usage or submit a scrap application',
  key50: 'Self-pickup Sign',
  key51: 'Self-pickup Person',
  key52: 'Self-pickup Time',
  key53: 'Structure Search',
  key54: 'Advanced Search',
  key55: 'Add Usage Record',
  key56: 'View Usage Record',
  key57: 'View Log',
  key58: 'Total usage: {0}; Received amount: {1}; Remaining available amount: {2}',
  key59: 'The sum of usage has equaled or exceeded the amount received at the time of receipt, and the usage record cannot be continued',
  key60: '{0} changed the usage from {1} to {2}, reason for modification: {3}',
  key61: 'Reason for modification: {0}',
  key62: ', reason for exceeding usage: {0}',
  key63: ',',
  key64: 'The current receipt has no usage record yet',
  key65: 'The current receipt has no modification log of the usage record',
  key66: 'Scan to add',
  key67: 'Scan to join',
  key68: 'Add',
  key69: 'Assignment record',
  key70: 'Recipient',
  key71: 'Add to Cart',
  key72: 'Bottle-Split Information',
  key73: 'Confirm',
  key74: 'Pre-booked Amount',
  key75: 'Remaining Amount',
  key76: 'Bottle-Split Amount',
  key77: 'Pre-booked Amount',
  key78: 'Bottle Splitting Reservation Info',
  key79: '{0} ({1}) Bottle Splitting Reservation Info',
  key80: 'Bottle-Split No.',
  key81: 'Requester',
  key82: 'Quantity',
  key83: 'Bottle-Split Record',
  key84: 'Applied Bottle-Split Quantity',
  key85: 'Actual Bottle-Split Quantity',
  key86: 'Application Time',
  key87: 'Resubmit',
  key88: 'View Issuance Information',
  key89: 'Are you sure you want to withdraw this bottle splitting record?',
  key90: 'Modify Bottle Splitting Issuance Information',
  key91: 'Please enter the inventory quantity for bottle splitting issuance',
  key92: 'Bottle Splitting Issuance Approval',
  key93: 'Sub-bottle Barcode',
  key94: 'Submit for approval',
  key95: 'Approval flow',
  key96: 'Step',
  key97: 'Please select an approver',
  key98: 'At least one approver must be selected',
  key99: 'Warehouse information is missing',
  key100: 'Select co-operator',
  key101: 'Co-operator',
  key102: 'Password',
  key103: 'Please select a co-operator',
  key104: 'Please enter the password',
  key105: 'No co-operator available',
  key106: 'Dual control',
  key107: 'The selected data can only contain one dual-control warehouse!',
  _key66: 'Batch Import',
  _key67: 'Click to download the import template',
  _key68: 'Select File',
  _key69: 'Import Result',
  _key70: 'Row Number',
  _key71: 'View More',
  _key72: 'Import Result',
  _key73: 'Please upload a file first',
  _key74: 'Import Successful',
  _key75: 'Import Failed',
};
